import { ofType } from 'redux-observable'
import { EMPTY, from, interval } from 'rxjs'
import { catchError, filter, ignoreElements, map, mergeMap } from 'rxjs/operators'
import { API } from 'aws-amplify'
import Actions from 'actions'
import { isUserOfRole } from 'utils/authUtils'
import { Roles } from 'consts/authConsts'
import { TAB_SESSION_ID } from 'utils/sessionUtils'
import { isOtherSessionPresence } from 'utils/presenceUtils'

const PRESENCE_ENDPOINT = '/notifications/v1/presence'
const PRUNE_INTERVAL_MS = 15000

// Best-effort POST of the local user's presence; never emits an action or surfaces errors.
export const reportPatientPresenceEpic = action$ =>
  action$.pipe(
    ofType(Actions.REPORT_PATIENT_PRESENCE),
    mergeMap(({ payload }) =>
      from(API.post('grinServerlessApi', PRESENCE_ENDPOINT, { body: payload })).pipe(
        ignoreElements(),
        catchError(() => EMPTY)
      )
    )
  )

// Turn incoming hiPresence IoT notifications into slice updates. We ingest presence from any
// session OTHER than this tab (teammates, and other sessions of our own account) and drop only
// this tab's own echo (matching sessionId).
export const onPatientPresenceReceivedEpic = action$ =>
  action$.pipe(
    ofType(Actions.NOTIFICATION_RECEIVED),
    // Defense-in-depth: even though the backend only delivers hiPresence to HI user topics,
    // refuse to ingest/store it on a non-HI client. UI hiding is not an authorization boundary.
    filter(
      ({ payload }) =>
        isOtherSessionPresence(payload, TAB_SESSION_ID) &&
        !!payload.patientId &&
        isUserOfRole([Roles.HI, Roles.HIAdmin])
    ),
    map(({ payload }) =>
      Actions.patientPresenceReceived({
        patientId: payload.patientId,
        action: payload.action,
        viewer: payload.viewer,
        now: Date.now()
      })
    )
  )

// Periodically prune stale viewers so crashed/closed sessions disappear without a 'close'.
export const prunePatientPresenceEpic = () =>
  interval(PRUNE_INTERVAL_MS).pipe(map(() => Actions.prunePatientPresence({ now: Date.now() })))
